import { CosmwasmWasmV1Types } from '@injectivelabs/core-proto-ts';
export const ContractCodeHistoryOperationTypeMap = CosmwasmWasmV1Types.ContractCodeHistoryOperationType;
